// extracted by mini-css-extract-plugin
export default {"card":"SkillCard_card__h6rKd","skillHeading":"SkillCard_skillHeading__GmKOA"};